webpackJsonp([70144966829960],{

/***/ 216:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(47);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactPage = function ContactPage(_ref) {
	  var transition = _ref.transition;
	  return _react2.default.createElement(
	    'div',
	    { style: transition && transition.style },
	    _react2.default.createElement(
	      'h1',
	      { className: 'pages_head' },
	      'Contact Me'
	    ),
	    _react2.default.createElement(
	      'form',
	      { name: 'contacting_select', method: 'POST', action: '/confirm/', 'data-netlify': 'true', 'netlify-honeypot': 'bot-field' },
	      _react2.default.createElement('input', { type: 'hidden', name: 'form-name', value: 'contacting_select' }),
	      _react2.default.createElement(
	        'label',
	        null,
	        'Your Name:'
	      ),
	      _react2.default.createElement('input', { type: 'text', name: 'name', placeholder: 'yourname' }),
	      _react2.default.createElement(
	        'label',
	        null,
	        'Your Email:'
	      ),
	      _react2.default.createElement('input', { type: 'email', name: 'email', placeholder: 'you@domain.com', required: true }),
	      _react2.default.createElement(
	        'label',
	        null,
	        'What Can I Help You With?:'
	      ),
	      _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'select',
	          { name: 'help-with' },
	          _react2.default.createElement(
	            'option',
	            { value: 'designing' },
	            'Designing Something'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'developing' },
	            'Developing Something'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'measuring' },
	            'Measuring My Marketing Mix'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'fixing' },
	            'Fixing Something Up'
	          ),
	          _react2.default.createElement(
	            'option',
	            { selected: true, value: 'all' },
	            'All of The Things'
	          ),
	          _react2.default.createElement(
	            'option',
	            { value: 'none' },
	            'None of the Things / Something Else'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'label',
	        null,
	        'Message:'
	      ),
	      _react2.default.createElement('textarea', { name: 'message' }),
	      _react2.default.createElement(
	        'button',
	        { type: 'submit' },
	        'Send'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'formfix' },
	        '\xA0'
	      )
	    )
	  );
	};
	
	exports.default = ContactPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-contact-js-422952bc8091b758ffe4.js